<!--
 * @Author: your name
 * @Date: 2021-01-09 20:19:11
 * @LastEditTime: 2021-01-13 17:21:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /java-pc/src/components/FooterBottom.vue
-->
<template>
  <div class="footer_bottom">
    <ul class="footer_list">
      本网站销售的所有产品仅用于工业应用或者科学研究等非医疗目的，不可用于人类或动物的临床诊断或治疗，非药用，非食用。
      <!-- <li v-for="({linkName,linkUrl},index) in navlist.data" :key="index">
        <a :href="linkUrl" target="_blank">
          {{linkName}}
        </a>
      </li> -->
    </ul>

    <div class="footer_info">
      <p class="copy_right">
        {{configInfo.basic_site_copyright}} {{L['版权所有']}} 
        <a href="https://beian.miit.gov.cn/" target="_blank">{{configInfo.basic_site_icp}}</a>
      </p>
      <div class="beian_group">
        <img src="https://shopping-shop.oss-cn-shanghai.aliyuncs.com/channel1aopumaiimages/seller/common/wanganlogo.png"/>
        <p class="copy_right">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502403997" target="_blank">沪公网安备31011502403997号</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, getCurrentInstance, ref } from 'vue'
  import { useStore } from 'vuex';
  export default {
    name: "FooterBottom",
    setup() {
      const navlist = reactive({ data: [] });
      const store = useStore();
      const configInfo = ref(store.state.configInfo)
      const { proxy } = getCurrentInstance();
      const L = proxy.$getCurLanguage();
      const getInitData = () => {
        const { proxy } = getCurrentInstance();
        proxy.$get('v3/cms/front/friendLink/list').then(res => {
          if (res.state == 200) {
            navlist.data = res.data;
          }
        })
      }
      getInitData();
      return { navlist, configInfo, L };
    },
  };
</script>

<style lang="scss" scoped>
  .footer_bottom {
    position: absolute;
    left: 50%;
    margin-left: -952px;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 1900px;
    // color: #888;
    color: #fff;
    font-size: 12px;
    // background-color: #2B2B2B;
    padding-bottom: 46px;
    overflow: hidden;

    .footer_list {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      color: #B7CEE0;
      font-size: 14px;
      li {
        position: relative;
        box-sizing: border-box;
        padding: 0 17px;
        // border-right: 1px solid rgba(255, 255, 255, 0.4);
        // color: #888;
        color: #fff;
        line-height: 19px;
        margin-bottom: 10px;
        cursor: pointer;

        &:after {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -6px;
          content: '';
          width: 1px;
          height: 12px;
          // background-color: #666;
          background-color: #fff;
        }

        a {
          // color: #888;
          // color: #fff;
          color: #A3B8C8;
          &:hover {
            // color: $colorMain3;
            color: #fff;
          }
        }
      }
    }

    li:last-child {
      border-right: none;
      &:after {
        content: none;
      }
    }
.footer_info {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    
    .beian_group {
      display: flex;
      align-items: center;
      
      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
    }
    .copy_right {
      // color: #fff;
      color: #B7CEE0;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 1px;
      margin-top: 9px;
      a {
        // color: #4c4c4c;
        color: #A3B8C8;
        &:hover {
          // color: $colorMain3;
          color: #fff;
        }
      }
    }

    .author {
      // color: #4c4c4c;
      color: #A3B8C8;
      font-size: 12px;
      cursor: default;
      &:hover {
        // color: $colorMain3;
        color: #fff;
      }
    }
  }
</style>